import {RD_SURVEYS} from '../actionTypes/index'

const initialState = {
    rdSurveysLoading: false,
    rdSurveysFullFill: null,
    rdSurveysError: null
}

const rdSurveysReducer = (state = initialState, action) => {
    switch (action.type) {
        case RD_SURVEYS.REQUEST:
            return {...state, rdSurveysLoading: true, rdSurveysError: null}
        case RD_SURVEYS.SUCCESS:
            return {...state, rdSurveysLoading: false, rdSurveysFullFill: action.payload, rdSurveysError: null}
        case RD_SURVEYS.ERROR:
            return {...state, rdSurveysLoading: false, rdSurveysFullFill: null, rdSurveysError: action.payload}
        default:
            return state
    }
}

export default rdSurveysReducer
